<template>
  <div>
    <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
      <el-button type="primary" @click="dialogVisible = true">新增轮播</el-button>
      <el-button type="primary" @click="openTitleDialog">编辑板块标题</el-button>
    </div>
    <el-card shadow="never">
      <el-table :data="tableData">
        <el-table-column prop="sortOrder" label="排序" width="70" />
        <!-- <el-table-column prop="bannerTitle" label="名称" width="100" /> -->
        <el-table-column prop="imageUrl" label="图片" width="130">
          <template #default="scope">
            <el-image :src="scope.row.bannerImageUrl" style="width: 100px;" />
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template #default="scope">
            <el-tag v-if="scope.row.isActive" type="success">启用</el-tag>
            <el-tag v-else type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="jumpUrl" label="跳转页面" />
        <el-table-column prop="createTime" label="创建时间" width="180" />
        <el-table-column prop="updateTime" label="更新时间" width="180" />
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button type="text" size="small" @click="editItem(scope.row)" style="margin-right: 10px;">编辑</el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.bannerId)">
              <template #reference>
                <el-button type="text" size="small">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

    </el-card>

    <!-- 新增轮播 -->
    <el-dialog :visible.sync="dialogVisible" :title="form.id ? '编辑轮播' : '添加轮播'" width="500px"
      :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" label-position="top">
        <!-- <el-form-item label="名称:">
          <el-input v-model="form.bannerTitle" />
        </el-form-item> -->
        <el-form-item label="图片:">
          <upload-cover v-model="form.bannerImageUrl" :limit="1" />
        </el-form-item>
        <el-form-item label="跳转页面:">
          <el-input v-model="form.jumpUrl" />
        </el-form-item>
        <el-form-item label="排序（数值越小越靠前）:">
          <el-input v-model="form.sortOrder" />
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="form.isActive" :active-value="true" :inactive-value="false" active-text="启用"
            inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveItem">确定</el-button>
      </template>
    </el-dialog>

    <!-- 编辑板块标题 -->
    <el-dialog :visible.sync="titleDialogVisible" title="编辑板块标题" width="500px"
      :close-on-click-modal="false">
      <el-form :model="titleForm" label-width="100px" label-position="top">
        <el-form-item label="板块标题:">
          <el-input v-model="titleForm.buttonText" placeholder="请输入板块标题" maxlength="10" show-word-limit />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="titleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTitle">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>


<script>
import uploadCover from '@/components/upload-cover/upload-cover.vue'
export default {
  components: {
    uploadCover
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.form = { isActive: true }
      }
    },
    // 关闭标题弹窗时清空表单
    titleDialogVisible(val) {
      if (!val) {
        this.titleForm = { buttonText: '' }
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        isActive: true
      },
      tableData: [],
      // 板块标题弹窗
      titleDialogVisible: false,
      titleForm: {
        buttonText: ''
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await this.$request.get("/cms/homepage_banners/list")
      if (res.data.code == 200) {
        this.tableData = res.data.data
      }
    },
    async deleteItem(id) {
      const res = await this.$request.get("/cms/homepage_banners/delete_id?id=" + id)
      if (res.data.code == 200) {
        this.$message.success("删除成功")
        this.getList()
      }
    },
    editItem(row) {
      this.form = this.$deepClone(row)
      this.dialogVisible = true
    },
    async saveItem() {
      const res = await this.$request.post(this.form.bannerId ? "/cms/homepage_banners/edit" : "/cms/homepage_banners/add", this.form)
      if (res.data.code == 200) {
        this.$message.success("操作成功")
        this.dialogVisible = false
        this.getList()
      }
    },
    // 打开板块标题弹窗并回显
    async openTitleDialog() {
      this.titleDialogVisible = true
      const res = await this.$request.get("/cms/homepage_button/query")
      if (res.data.code == 200) {
        this.titleForm.buttonText = (res.data.data && res.data.data.buttonText) || ''
      }
    },
    // 保存板块标题
    async saveTitle() {
      const res = await this.$request.post("/cms/homepage_button/update", {
        buttonText: this.titleForm.buttonText
      })
      if (res.data.code == 200) {
        this.$message.success("操作成功")
        this.titleDialogVisible = false
      }
    }
  }
}
</script>